import { useMemo } from 'react';

import { useCurrentBusiness } from '../businesses/useCurrentBusiness';
import { useCurrentOutlet } from '../outlets/useCurrentOutlet';
import { useOrders } from '../orders/useOrders';

import type { QueryOptions } from '../types';

export const useStaffOrders = (
  options: QueryOptions = {
    enabled: true,
    // refetchOnWindowFocus: 'always',
    staleTime: 1 * 60 * 1000, // 1 minutes
  }
) => {
  const { currentBusiness, isLoading: businessLoading } = useCurrentBusiness();
  const { currentOutlet, isLoading: outletLoading } = useCurrentOutlet();

  const businessId = currentBusiness?.id;
  const outletId = currentOutlet?.id;

  const { orders, isLoading, queryKey, ...rest } = useOrders(
    { businessId, outletId, status: ['active', 'requested'] },
    {
      ...options,
      enabled: !!businessId && !!outletId && options.enabled,
    }
  );

  const requestedOrders = useMemo(() => {
    return orders.filter(
      ({ status }: { status: any }) => status === 'requested'
    );
  }, [orders]);

  const activeOrders = useMemo(() => {
    return orders.filter(({ status }: { status: any }) => status === 'active');
  }, [orders]);

  return {
    orders,
    activeOrders,
    requestedOrders,
    isLoading: isLoading || businessLoading || outletLoading,
    queryKey,
    ...rest,
  };
};
